<em class="d-block" i18n>Video name/description and comments that contain any of the watched words are automatically tagged with the name of the list.</em>
<em class="d-block mb-3" i18n>These automatic tags can be used to filter comments and videos.</em>

<my-watched-words-list-admin-owner mode="admin"></my-watched-words-list-admin-owner>

